(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
(function () {
  var formWrap = document.getElementById('coming-soon-form-wrap');
  var form = document.getElementById('coming-soon-email-form');

  if (!formWrap || !form) return;

  var errorEl = document.getElementById('coming-soon-error');

  // ── UTM / attribution capture ──────────────────────────────────────────────
  function captureUtms() {
    try {
      if (sessionStorage.getItem('rolly_utms')) return;
      var params = new URLSearchParams(window.location.search);
      var utms = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = params.get(k);
        if (v) utms[k] = v;
      });
      if (document.referrer) utms['referrer'] = document.referrer;
      utms['first_page'] = window.location.href;
      sessionStorage.setItem('rolly_utms', JSON.stringify(utms));
    } catch (e) {}
  }

  function getStoredUtms() {
    try { return JSON.parse(sessionStorage.getItem('rolly_utms') || '{}'); } catch (e) { return {}; }
  }

  captureUtms();

  var key = formWrap.dataset.klaviyoKey;

  function showError(msg) {
    errorEl.textContent = msg || errorEl.dataset.default;
    errorEl.hidden = false;
  }

  function getMarketingConsent() {
    try {
      var raw = localStorage.getItem('rolly_consent_v1');
      if (raw) {
        var state = JSON.parse(raw);
        if (typeof state.marketing === 'boolean') return state.marketing;
      }
    } catch (e) {}
    try {
      if (window.silktideConsentManager) {
        var choice = window.silktideConsentManager.getInstance().getConsentChoice('marketing');
        if (typeof choice === 'boolean') return choice;
      }
    } catch (e) {}
    return null;
  }

  document.addEventListener('rolly:consent', function (e) {
    if (e.detail && e.detail.marketing && !errorEl.hidden) {
      errorEl.hidden = true;
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    var consent = getMarketingConsent();
    if (consent === null) {
      showError(errorEl.dataset.consentRequired);
      return;
    }
    if (!consent) {
      showError(errorEl.dataset.consentRejected);
      return;
    }

    var email = form.querySelector('input[type="email"]').value.trim();
    var list = formWrap.dataset.klaviyoList;

    if (!key || !list || !email) {
      showError();
      return;
    }

    var utms = getStoredUtms();
    var properties = Object.assign({
      signup_source: 'password_page',
      signup_date: new Date().toISOString().split('T')[0],
      signup_url: utms.first_page || window.location.href
    }, utms);

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-01-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Password Page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: properties
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: list
              }
            }
          }
        }
      })
    })
    .then(function (res) {
      if (res.status === 202) {
        // Enrich profile with location via IP geolocation — silent fail, non-blocking
        fetch('https://ipapi.co/json/')
          .then(function (r) { return r.json(); })
          .then(function (geo) {
            var loc = {};
            if (geo.city)         loc.city      = geo.city;
            if (geo.region)       loc.region    = geo.region;
            if (geo.country_code) loc.country   = geo.country_code;
            if (geo.postal)       loc.zip       = geo.postal;
            if (geo.timezone)     loc.timezone  = geo.timezone;
            if (geo.latitude)     loc.latitude  = geo.latitude;
            if (geo.longitude)    loc.longitude = geo.longitude;
            if (!Object.keys(loc).length) return;
            return fetch(
              'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(key),
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'revision': '2026-01-15' },
                body: JSON.stringify({
                  data: {
                    type: 'profile',
                    attributes: { email: email, location: loc }
                  }
                })
              }
            );
          })
          .catch(function () {});

        var successEl = document.createElement('p');
        successEl.className = 'coming-soon__success';
        successEl.textContent = formWrap.dataset.success;

        formWrap.replaceChildren(successEl);
      } else {
        return res.text().then(function (t) {
          console.error('Klaviyo error:', t);
          showError();
        });
      }
    })
    .catch(function (err) {
      console.error(err);
      showError();
    });
  });
})();

(function () {
  var cookieBtn = document.getElementById('cs-cookie-settings');
  if (!cookieBtn) return;
  cookieBtn.addEventListener('click', function () {
    try {
      window.silktideConsentManager.resetConsent();
    } catch (e) {
      try { localStorage.removeItem('rolly_consent_v1'); } catch (ex) {}
      location.reload();
    }
  });
})();

(function () {
  var dialog = document.getElementById('cs-privacy-dialog');
  if (!dialog) return;
  var openBtn = document.querySelector('.coming-soon__privacy-link');
  var closeBtn = dialog.querySelector('.coming-soon__privacy-close');
  if (openBtn) {
    openBtn.addEventListener('click', function () {
      dialog.showModal();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dialog.close();
    });
  }
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) {
      dialog.close();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
